import React, { useEffect } from "react";
import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import PageLoading from "../../helpers/PageLoading";
import { currencyValues, getError } from "../../store/helpers/common_functions";
import { useHistory } from "react-router-dom";
import CardFinanceStats from "../../components/Cards/CardFinanceStats";
import { CardContent, CardHeader, FormControl, Paper } from "@mui/material";
import moment from "moment";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { CardTitle } from "reactstrap";

function FinanceDashboard({ FetchDetails, loggedUser, SetSelectedMenu }) {
  const [loading, setLoading] = React.useState(false);

  const [showDateInputs, setShowDateInputs] = React.useState(false);
  const [error, setError] = React.useState();
  const [info, setInfo] = React.useState();
  const [selectedRange, setSelectedRange] = React.useState(null);
  const [currency, setCurrency] = React.useState("rwf");
  const [period, setPeriod] = React.useState({
    startDate: moment().startOf("year").format("YYYY-MM-DD HH:mm:ss"),
    endDate: moment().endOf("year").format("YYYY-MM-DD HH:mm:ss"),
  });
  const [currentYear, setCurrentYear] = React.useState(
    new Date().getFullYear()
  );

  const toggleDateInputs = () => {
    setShowDateInputs(!showDateInputs);
  };

  const handleChangeDate = (e) => {
    const selectedYear = e.target.value;
    setCurrentYear(selectedYear);
    setPeriod({
      startDate: moment(selectedYear)
        .startOf("year")
        .format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(selectedYear).endOf("year").format("YYYY-MM-DD HH:mm:ss"),
    });
  };

  const loadData = async () => {
    setLoading(true);
    setError(null);
    const resp = await FetchDetails(
      `/api/finance/dashboard/index/?currency=${currency}&${
        period ? `period=${JSON.stringify(period)}` : ""
      }`
    );
    setLoading(false);
    if (resp.status) {
      setInfo(resp.data);
    } else {
      setError(getError(resp));
    }
    return resp;
  };

  useEffect(() => {
    SetSelectedMenu({
      menu: "finance_team",
      title: "DASHBOARD",
    });
    setPeriod({
      startDate: moment().startOf("year").format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment().endOf("year").format("YYYY-MM-DD HH:mm:ss"),
    });
    setSelectedRange("thisYear");
  }, []);

  useEffect(() => {
    loadData().then();
  }, [FetchDetails, currency, period]);

  const history = useHistory();
  const years = [
    { label: "2018", value: 2018 },
    { label: "2019", value: 2019 },
    { label: "2020", value: 2020 },
    { label: "2021", value: 2021 },
    { label: "2022", value: 2022 },
    { label: "2023", value: 2023 },
    { label: "2024", value: 2024 },
    { label: "2025", value: 2025 },
  ];
  const DateRangeButtons = ({ setPeriod, selectedRange, setSelectedRange }) => {
    const setDateRange = (range) => {
      let startDate, endDate;

      switch (range) {
        case "thisMonth":
          startDate = moment().startOf("month").format("YYYY-MM-DD HH:mm:ss");
          endDate = moment().endOf("month").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "lastMonth":
          startDate = moment()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD HH:mm:ss");
          endDate = moment()
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD HH:mm:ss");
          break;
        case "thisYear":
          startDate = moment().startOf("year").format("YYYY-MM-DD HH:mm:ss");
          endDate = moment().endOf("year").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "lastYear":
          startDate = moment()
            .subtract(1, "year")
            .startOf("year")
            .format("YYYY-MM-DD HH:mm:ss");
          endDate = moment()
            .subtract(1, "year")
            .endOf("year")
            .format("YYYY-MM-DD HH:mm:ss");
          break;
        default:
          return;
      }

      setPeriod({ startDate, endDate });
      setSelectedRange(range);
    };

    return (
      <div className="flex space-x-0">
        {["thisMonth", "lastMonth", "thisYear", "lastYear"].map((range) => (
          <button
            key={range}
            type="button"
            style={{
              backgroundColor: selectedRange === range ? "#064163" : "white",
              color: selectedRange === range ? "white" : "black",
              border: "2px solid ",
            }}
            className="px-4 py-2 rounded-md"
            onClick={() => setDateRange(range)}
          >
            {range === "thisMonth" && "This Month"}
            {range === "lastMonth" && "Last Month"}
            {range === "thisYear" && "This Year"}
            {range === "lastYear" && "Last Year"}
          </button>
        ))}
      </div>
    );
  };

  const currencyJSX = (
    <FormControl fullWidth={false} size={"small"}>
      <InputLabel id="demo-simple-select-label">Currency</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={currency}
        label="Currency"
        onChange={(e) => setCurrency(e.target.value)}
      >
        {currencyValues.map((v) => (
          <MenuItem key={v.value} value={v.value}>
            {v.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  return (loading && !info) || error || !info ? (
    <PageLoading error={loading ? null : error} onRefresh={loadData} />
  ) : (
    <div className="mb-5">
      <div className="px-6 bg-white rounded-lg shadow-md ">
        <div className={"text-center"}>
  
              <div className="mb-5 ">
                <div className="flex justify-between items-center">
                  <div className="flex flex-col items-start relative my-6">
                    <div className="flex space-x-4">
                      <DateRangeButtons
                        setPeriod={setPeriod}
                        selectedRange={selectedRange}
                        setSelectedRange={setSelectedRange}
                      />
                      <div className="ml-6">
                        <button
                          onClick={toggleDateInputs}
                          className="px-4 py-2 text-gray-800 border border-gray-400 rounded-md flex items-center space-x-2"
                        >
                          <i className="fas fa-calendar-alt text-black"></i>
                          <span>Select Period</span>
                        </button>
                      </div>
                    </div>
                    {showDateInputs && (
                      <div
                        className="absolute right-0 bg-white p-4 border border-gray-400 rounded-md shadow-lg w-64 text-right"
                        style={{
                          top: `calc(100%)`,
                          zIndex: 10,
                          right: "10px",
                          marginRight: "-20px",
                        }}
                      >
                        {/* From and To date range */}
                        <div className="flex flex-col gap-4 mb-4">
                          {/* close icon */}
                          <div className="flex justify-end">
                            <button
                              onClick={toggleDateInputs}
                              className="text-gray-500 hover:text-gray-700"
                              style={{ fontSize: "1rem" }}
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                          <div className="flex justify-between items-center">
                            <label
                              htmlFor="startDate"
                              className="text-sm font-semibold text-gray-700"
                            >
                              From
                            </label>
                            <input
                              id="startDate"
                              type="date"
                              value={moment(period.startDate).format(
                                "YYYY-MM-DD"
                              )}
                              onChange={(e) =>
                                setPeriod({
                                  ...period,
                                  startDate: moment(e.target.value).format(
                                    "YYYY-MM-DD"
                                  ),
                                })
                              }
                              className="border border-gray-300 rounded-md p-2 w-32 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition"
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <label
                              htmlFor="endDate"
                              className="text-sm font-semibold text-gray-700"
                            >
                              To
                            </label>
                            <input
                              id="endDate"
                              type="date"
                              value={moment(period.endDate).format(
                                "YYYY-MM-DD"
                              )}
                              onChange={(e) =>
                                setPeriod({
                                  ...period,
                                  endDate: moment(e.target.value).format(
                                    "YYYY-MM-DD"
                                  ),
                                })
                              }
                              className="border border-gray-300 rounded-md p-2 w-32 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Card stats */}
              <h1 className="text-black text-left ml-6 font-semibold text-12px">
                <div className="text-right">{currencyJSX}</div>
                PROJECTS
              </h1>
              <div className="flex flex-wrap ">
                <div className="w-full lg:w-6/12 xl:w-4/12 p-8">
                  <CardFinanceStats
                    tailwindStyles="bg-primary text-white"
                    statSubtitle={`Total Budget`}
                    statTitle={
                      <span style={{ fontWeight: "bold", color: "white" }}>
                        {`${info?.totalBudget?.toLocaleString(0, {
                          maximumFractionDigits: 2,
                        }) ?? 0} `}
                      </span>
                    }
          
                    statArrow="up"
                    statIconName="fas fa-chart-line"
                    statIconColor="bg-qt"
                  />
                </div>
                <div className="w-full lg:w-6/12 xl:w-4/12 p-8">
                  <CardFinanceStats
                    tailwindStyles="bg-white text-black"
                    statSubtitle={`Total Allocated`}
              
                    statTitle={
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        {`${info?.totalAllocated?.toLocaleString(0, {
                          maximumFractionDigits: 2,
                        }) ?? 0} `}
                      </span>
                    }
                    statIconName="fas fa-file-invoice-dollar"
                    statIconColor="bg-qt"
                  />
                </div>
                <div className="w-full lg:w-6/12 xl:w-4/12 p-8">
                  <CardFinanceStats
                    tailwindStyles="bg-white text-black"
                    statSubtitle={`Balance`}
                    statTitle={
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        {`${info?.balance?.toLocaleString(0, {
                          maximumFractionDigits: 2,
                        }) ?? 0} `}
                      </span>
                    }
                   
                    statIconName="fas fa-comments-dollar"
                    statIconColor="bg-qt"
                  />
                </div>
              </div>
    
        </div>
        {/* <div className={"relative text-left"}>
          <div className="relative text-left" style={{ marginLeft: "4.5rem" }}>
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <CardTitle className="text-black text-left font-semibold text-12px ">
                PRODUCTS
              </CardTitle>
            </div>
          </div>
          <CardContent>
            <div className={"mb-4  p-2  "}>
              <div className="flex flex-wrap ">
                <div
                  className="w-full lg:w-6/12 xl:w-4/12 p-8"
                  style={
                    {
                      // width: "33%",
                      // maxWidth: "50%",
                      // height: "200px",
                      // padding: "2rem",
                    }
                  }
                >
                  <CardFinanceStats
                    statSubtitle={`Expected revenue`}
                    statTitle={
                      <span className="font-bold text-ellipsis overflow-hidden whitespace-nowrap ">
                        {info?.product && info?.product?.expected
                          ? info?.product?.expected.toLocaleString(0, {
                              maximumFractionDigits: 2,
                            })
                          : 0}
                      </span>
                    }
                    tailwindStyles="bg-primary text-white "
                    statArrow="up"
                    statIconName="fas fa-chart-line"
                    statIconColor="bg-qt"
                  />
                </div>
                <div className="w-full lg:w-6/12 xl:w-4/12 p-8">
                  <CardFinanceStats
                    statSubtitle={`expenditures`}
                    tailwindStyles="bg-white"
                    statTitle={
                      <span className="font-bold">
                        {info?.product && info?.product?.expenses
                          ? info?.product?.expenses.toLocaleString(0, {
                              maximumFractionDigits: 2,
                            })
                          : 0}
                      </span>
                    }
                    statIconName="fas fa-file-invoice-dollar"
                    statIconColor="bg-qt"
                  />
                </div>
                <div className="w-full lg:w-6/12 xl:w-4/12 p-8">
                  <CardFinanceStats
                    statSubtitle="Estimated Profit"
                    statTitle={
                      <span
                        className="font-bold"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {info?.product && info?.product?.estimatedProfit
                          ? info?.product?.estimatedProfit.toLocaleString(0, {
                              maximumFractionDigits: 2,
                            })
                          : 0}
                      </span>
                    }
                    tailwindStyles="bg-white text-black flex items-center justify-between"
                    statIconName="fas fa-comments-dollar"
                    statIconColor="bg-qt"
                    statIconSize="text-xl"
                  />
                </div>
              </div>
            </div>
          </CardContent>
        </div> */}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FinanceDashboard);
